var xml2js = require('xml2js');

module.exports = function(input, options) {
    return new Promise(function(resolve, reject) {
        xml2js.parseString(input, options, function(err, result) {
            if (!err) {
                resolve(result);
            } else {
                reject(err);
            }
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/xml2js-es6-promise/xml2js-es6-promise.js
// module id = 430
// module chunks = 0 1 2 5